import { faRotateRight } from '@fortawesome/pro-regular-svg-icons';
import { NotificationDispatch } from '@tryhackme/thm-ui-components';
import { useState } from 'react';
import { useResetRoomMutation } from '../../manage-room.slice';
import type { ManageRoomDetail } from '../../manage-room.types';
import { ModalLayout } from '../modal';
import { SettingCard } from '../setting-card';
import { StyledDescriptionText } from './reset-tab.styles';
interface ResetTabProps {
  roomDetails: ManageRoomDetail;
}
export const ResetTab = ({
  roomDetails
}: ResetTabProps) => {
  const [openModal, setOpenModal] = useState(false);
  const [resetRoom, {
    isLoading
  }] = useResetRoomMutation();
  const handleReset = async () => {
    try {
      await resetRoom({
        roomCode: roomDetails.code
      }).unwrap();
      NotificationDispatch('success', 'Room has been reset successfully');
    } catch {
      NotificationDispatch('error', 'Uh-oh. There was an error while resetting your room. Please try again.');
    } finally {
      setOpenModal(false);
    }
  };
  return <SettingCard icon={faRotateRight} title="Reset Room" data-sentry-element="SettingCard" data-sentry-component="ResetTab" data-sentry-source-file="reset-tab.tsx">
      <StyledDescriptionText data-sentry-element="StyledDescriptionText" data-sentry-source-file="reset-tab.tsx">
        This will reset all room data to its initial state. This action cannot be undone.
      </StyledDescriptionText>

      <ModalLayout open={openModal} openChange={setOpenModal} triggerButtonColor="error" triggerText="Reset room" modalTitleText="Reset room" closeButtonText="Cancel" actionButtonText={isLoading ? 'Resetting room' : 'Reset room'} actionButtonColor="error"
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    handleActionButton={handleReset} showWarnBox={false} data-sentry-element="ModalLayout" data-sentry-source-file="reset-tab.tsx">
        <p>Are you sure you want to reset the room &ldquo;{roomDetails.title}&rdquo;? This action cannot be undone.</p>
      </ModalLayout>
    </SettingCard>;
};